import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";

import { BoxTokenizationCertificate } from "./TokenizationCertificate.style";
import { IconClip } from "assets/icons/config";
import { useQuery } from "hooks/useQuery";
import { uploadTokenizationCertificate } from "services/tokenizationTransaction";

export const TokenizationCertificate = ({
  onCancel = () => null,
  reference = null,
}) => {
  const query = useQuery();

  const currentBrand = query.get("b");

  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState({
    severity: "success",
    message: "",
    active: false,
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    e.target?.closest("form")?.reset();
  };

  const handleAccept = () => {
    if (status.active && status.severity === "success") {
      return;
    }

    if (!reference) {
      setStatus({
        active: true,
        severity: "error",
        message: "No se ha encontrado una referencia",
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("reference", reference);
    formData.append("brand", currentBrand);

    uploadTokenizationCertificate(formData)
      .then(({ data }) => {
        setStatus({
          active: true,
          severity: data?.status ?? "error",
          message: data?.message ?? "Error al subir el archivo",
        });
      })
      .catch((error) => {
        let message =
          error.response?.data?.message ?? "Error al subir el archivo";

        if (Array.isArray(message)) {
          message = message[0]?.message ?? "Error al subir el archivo";
        }

        setStatus({ active: true, severity: "error", message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <BoxTokenizationCertificate>
      {(status.active && status.severity !== "success") || !status.active ? (
        <>
          <Typography variant="h4" color="primary" gutterBottom>
            Subir certificado
          </Typography>
          <Typography variant="body1">
            Sube un certificado de cuenta bancaria para finalizar la inscripción
            del método de pago.
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="h4" color="primary" gutterBottom>
            ¡Listo!
          </Typography>
          <Typography variant="body1">{status.message}</Typography>
        </>
      )}

      <input
        id="file-upload"
        type="file"
        accept=".pdf"
        style={{ display: "none" }}
        hidden
        onChange={handleFileChange}
      />
      <br />
      <Box className="BoxTokenizationCertificate__actions">
        {((status.active && status.severity !== "success") ||
          !status.active) && (
          <Button
            variant="contained"
            component="label"
            htmlFor="file-upload"
            size="small"
            startIcon={<IconClip size={14} color="currentColor" />}
            className="upload-button"
          >
            <Typography noWrap fontSize={12} color="inherit" component="span">
              Subir certificado
            </Typography>
          </Button>
        )}
        <Typography variant="body1" fontSize={12} noWrap className="file-name">
          {file ? file.name : "No se ha subido ningún archivo"}
        </Typography>
      </Box>

      {status.active && status.severity !== "success" && (
        <>
          <br />
          <Alert severity="error">{status.message}</Alert>
        </>
      )}

      <Box className="BoxTokenizationCertificate__buttons">
        {((status.active && status.severity !== "success") ||
          !status.active) && (
          <Button variant="outlined" color="primary" onClick={onCancel}>
            Cancelar
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          disabled={!file}
          onClick={handleAccept}
          loading={loading}
        >
          Aceptar
        </Button>
      </Box>
    </BoxTokenizationCertificate>
  );
};
